enum EXAMINATION_ACTION_TYPE {
  NORMAL = 0,
  CLICKBCD = 1,
  ADDEDNEWBCD = 2,
  DELETEBCD = 3,
  CLICKNDV = 4,
  DETAILINFO = 5,
  SEARCHDMDV = 6,
}
enum TT_PHIEU_KHAM {
  PKM = 0,
  CTH = 1,
  DTH = 2,
  HT = 3,
  CKQ = 4,
  DCKQ = 5,
  H = 6,
  X = 7,
  CTN = 8,
}
enum EXAM_BTN_CLICK_TYPE {
  NONE = 0,
  SAVE = 1,
  SAVEPRINT = 2,
  COMPLETEKBNT = 3,
  PATIENTTT = 4,
  CANCEL = 5,
  PAUSE = 6,
  WAITRESULT = 7,
  RELOAD_LIST_EXAM = 8,
  RELOAD_LIST_GT = 9,
}
export {EXAMINATION_ACTION_TYPE, EXAM_BTN_CLICK_TYPE, TT_PHIEU_KHAM};
